import { useMemo } from "react";
import useJsonLd from "../hooks/useJsonLd";
import { organizationSchema, localBusinessSchema, websiteSchema } from "./schema";

/**
 * Har page par ek baar — Organization + HardwareStore (local) + WebSite JSON-LD.
 * App.tsx me mount hai. Data src/config/business.ts se; wahi ek jagah badlo.
 */
const SiteSchema = () => {
  const org = useMemo(() => organizationSchema(), []);
  const store = useMemo(() => localBusinessSchema(), []);
  const site = useMemo(() => websiteSchema(), []);
  useJsonLd("org", org);
  useJsonLd("store", store);
  useJsonLd("website", site);
  return null;
};

export default SiteSchema;
